import { easylease, yomacarshare, yomarentalasia, yomaleasing_main_menu, yomaautomart } from './FooterMenu';
import yf_operating_lease from '../assets/logo/yomafleet_easy_lease.png';
import yf_car_share from '../assets/logo/yomafleet_car_share.png';
import yf_truck_trailer from '../assets/logo/yomafleet_truck_and_trailer.png';
import yf_car_sales from '../assets/logo/yomafleet_car_sales.png';
import yf_least_to_buy from '../assets/logo/yomafleet_least_to_buy.png';
const yoma_fleet_description =
    'A Complete and cost effective vehicle management solution from procurement to delivery, maintenance, replacement and after sales service.';
const car_share_description =
    'Yoma Car Share is the leading self-drive online car rental service in Myanmar. Yoma Car Share is available nationwide and its rental hubs are at major airports and in main urban areas of the cities.';
const lease_to_by_description =
    ' Vehicle and equipment financing solution that is designed to help customers drive brand-new vehicles/ operates brand-new equipment for a low initial outlay and fixed monthly payments.';
const car_sale_description =
    'An Online vehicle auction site which allows automotive dealers and individuals in Myanmar to place bids and purchase the pre-owned Yoma Fleet vehicles.';
const truck_and_trailer_description =
    'A leading technology driven truck/trailer solution platform focused on delivering dedicated solutions to cover spikes in demand nationwide.';
const leasing = [
    {
        product: {
            logo: yf_operating_lease,
            title: 'Individual',
            descripton: yoma_fleet_description,
            browse: true,
            url1: '/vehicle',
            url2: '/solution/business',
            is_main_product: true,
        },
        menu: [easylease],
    },
    // {product: {logo: yf_operating_lease ,title: 'Solutions for Business', descripton: easy_lease_description, browse: true, url: '/solution/business', is_main_product: true}, menu: []}
    // {product: {logo: yf_operating_lease ,title: 'Solutions for Business', descripton: easy_lease_description, browse: true, url: '/solution/business', is_main_product: true}, menu: [operatinglease]}
];

const dailyrental = [
    {
        product: {
            logo: yf_car_share,
            title: 'Car Share',
            descripton: car_share_description,
            browse: true,
            url: 'https://www.yomacarshare.com',
            is_main_product: false,
        },
        menu: [yomacarshare],
    },
    {
        product: {
            logo: yf_truck_trailer,
            title: 'Truck and Trailer',
            descripton: truck_and_trailer_description,
            browse: true,
            url: 'https://www.yomarentals.asia/',
            is_main_product: false,
        },
        menu: [yomarentalasia],
    },
];

const buy = [
    {
        product: {
            logo: yf_car_sales,
            title: 'Car Sales',
            descripton: car_sale_description,
            browse: true,
            url: 'https://www.yomaautomart.com',
            is_main_product: false,
        },
        menu: [yomaleasing_main_menu],
    },
    {
        product: {
            logo: yf_least_to_buy,
            title: 'Lease to buy',
            descripton: lease_to_by_description,
            browse: true,
            url: 'https://www.yomaleasing.com',
            is_main_product: false,
        },
        menu: [yomaautomart],
    },
];

export { leasing, dailyrental, buy };
